import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
import {HttpStatusCodes} from '../../util/uiconstants';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */

export default function signOffsReducer(state = initialState.signOffs, action) {
	switch (action.type) {
		case types.ADD_APPROVAL_FOR_SEM: {
			let signOffs = _.cloneDeep(state);
			signOffs.push(action.response);
			return signOffs;
		}
		case types.DELETE_APPROVAL_FOR_SEM: {
			let signOffs = _.cloneDeep(state);
			signOffs = signOffs.filter((signoff) => signoff.approvalId != action.meta.api.data.approvalId);
			return signOffs;
		}
		case types.CLEAN_APPROVAL: {
			return {};
		}
		case types.GET_DOCUMENT_SIGN_OFFS: {
			if (action.response) {
				return action.response || state;
			}
			return state;
		}
		case types.LOAD_SIGN_OFF: {
			if (!_.isEmpty(action.signOffs)) {
				return action.signOffs;
			}

			return [];
		}
		case types.ADD_APPROVAL_FOR_DOCUMENT: {
			const responseObj = action?.responseObj;
			const response = action?.response || null;
			if (responseObj?.status === HttpStatusCodes.Ok && response) {
				let approvals = [...state, action.response];
				let uniqueApprovals = new Map();
				approvals.forEach((item) => {
					uniqueApprovals.set(item.approvalId, item);
				});
				return Array.from(uniqueApprovals.values());
			}
			return state;
		}
		case types.REMOVE_APPROVAL_FOR_DOCUMENT: {
			const responseObj = action?.responseObj;
			if (responseObj?.status === HttpStatusCodes.NoContent) {
				const approvals = state.filter((approval) => approval.approvalId !== action?.meta?.api?.data?.approvalId);
				return approvals;
			}
			return state;
		}
		default:
			return state;
	}
}
